import {
    getAssignmentAtStepApi,
    submitGenerateResponseDataApi,
    submitTurnDataApi,
} from 'HTTPClients/customTask'
import { createSubmissionApi } from 'HTTPClients/tasks.client'
import { AssignmentResponseType } from 'Services/tasks.service'
import {
    CustomGenerateResponsePayload,
    StatusType,
    SupplementDataType,
    UpdatedAttributesData,
} from 'Types/Tasks.types'
import { sanitizeAxiosError } from 'Utils/common.utils.ts'

export const getAssignmentAtStep = async (
    userId: string,
    stepId: string
): Promise<AssignmentResponseType | undefined> => {
    const assignmentResp = await getAssignmentAtStepApi(userId, stepId)
    if (!assignmentResp.isOk()) {
        throw new Error(sanitizeAxiosError(assignmentResp.error) ?? 'Failed to fetch assignment')
    }

    if (
        assignmentResp.value.assignment.status === StatusType.ASSIGNED ||
        assignmentResp.value.assignment.status === StatusType.TO_BE_ASSIGNED
    ) {
        const submissionResp = await createSubmissionApi(assignmentResp.value.assignment.id)
        if (!submissionResp.isOk()) {
            console.error(submissionResp.error)
            throw new Error(
                sanitizeAxiosError(submissionResp.error) ?? 'Failed to create submission'
            )
        }
        return {
            assignmentResp: assignmentResp.value,
            submissionResp: submissionResp.value,
        }
    }

    return {
        assignmentResp: assignmentResp.value,
    }
}

export const submitGenerateResponseData = async (
    userId: string,
    submissionId: string,
    timeElapsedInSeconds: number,
    data: CustomGenerateResponsePayload,
    attributes: UpdatedAttributesData = {},
    supplement?: SupplementDataType
): Promise<ReadableStreamDefaultReader<Uint8Array> | undefined> => {
    const reader = await submitGenerateResponseDataApi(
        userId,
        submissionId,
        timeElapsedInSeconds,
        data,
        attributes,
        supplement
    )
    if (!reader.isOk()) {
        throw new Error('Failed to fetch response')
    }
    return reader.value
}

export const submitTurnData = async (
    userId: string,
    submissionId: string,
    timeElapsedInSeconds: number,
    data: unknown
): Promise<ReadableStreamDefaultReader<Uint8Array> | undefined> => {
    const reader = await submitTurnDataApi(userId, submissionId, timeElapsedInSeconds, data)
    if (!reader.isOk()) {
        throw new Error('Failed to fetch response')
    }
    return reader.value
}
